// extracted by mini-css-extract-plugin
export var copyIcon = "_yd-2";
export var discountCard = "_yd-0";
export var discountCode = "_yd-3";
export var discountContent = "_yd-1";
export var loadingCard = "_yd-4";